import { render, staticRenderFns } from "./IndagineEpidemiologicaAltriCasiParticolariEditComponent.vue?vue&type=template&id=7b8b483a"
import script from "./IndagineEpidemiologicaAltriCasiParticolariEditComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaAltriCasiParticolariEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports